<template>
  <el-container class="h-100 w-100 bg-ff">
    <el-aside width="120px">
      <div class="title border-b-e2">图纸资料</div>
      <div class="menu">
        <div v-for="(item, index) in menu" :key="index" :class="index === menuIndex ? 'menuActive': 'menuList'" @click="changeIndex(index,item.name,item.type,item.id)">
          <span class="cursor">{{item.name}}</span>
        </div>
      </div>
    </el-aside>
    <el-main class="flex-column">
      <div class="customerInfo flex align-center justify-space-between">
        <div class="flex align-center">
          <div>
            <div><span>客户信息：</span>{{info.name}}</div>
            <div><span>装修地址：</span>{{info.detailedAddress}}</div>
          </div>
        </div>
        <div class="close flex align-center justify-center cursor" @click="onClose">
          <i class="el-icon-close font-18-ff"></i>
        </div>
      </div>
      <div class="content flex-column flex-1 bg-f3f4f7">
        <FileItem :titleName="titleName" v-if="drawingType === 1" :drawingType="drawingType" :picId="picId" :plan="plan" :info="info"></FileItem>
        <PicItem :titleName="titleName" v-else-if="drawingType === 2" :drawingType="drawingType" :picId="picId" :plan="plan" :info="info"></PicItem>
        <div style="margin-top: 10px;">
          <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import FileItem from './drawingItem/fileItem'
import PicItem from './drawingItem/picItem'
import Pagination from '../../components/Pagination'
export default {
  name: 'drawings',
  components: {FileItem, PicItem, Pagination},
  data () {
    return {
      id: null,
      info: {},
      menuIndex: 0,
      menu: [],
      titleName: '',
      drawingType: 1,
      picId: null,
      classifyId: '',
      plan: [],
      page: 1,
      limit: 10,
      pageSize: 10, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 10, // 当前页条数
      total: 100 // 总条数
    }
  },
  created () {
    this.customerFileClassify()
    this.id = this.$route.query.id
    this.getInfo()
  },
  mounted () {
  },
  methods: {
    getInfo () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/getById`, this.qs.stringify({
        id: this.id
      })).then(res => {
        if (res.data.success) {
          this.info = res.data.data
          this.queryData()
        }
      })
    },
    onClose () {
      this.$router.go(-1)
    },
    changeIndex (a, b, c, d) {
      this.menuIndex = a
      this.titleName = b
      this.drawingType = c
      this.picId = d
      this.queryData()
    },
    customerFileClassify () {
      this.axios.post(`${this.$store.state.API_URL_9010}/customerFileClassify/list`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          this.menu = res.data.data
          this.titleName = res.data.data[0].name
          this.drawingType = res.data.data[0].type
          this.picId = res.data.data[0].id
          // this.classifyId = res.data.data[0].id
          this.plan = []
          this.queryData()
        }
      })
    },
    queryData () {
      if (this.info.id) {
        this.axios.post(`${this.$store.state.API_URL_9010}/customerFile/queryForPage`, {
          classifyId: this.picId,
          customerId: this.info.id,
          page: this.page,
          limit: this.limit
        }).then(res => {
          if (res.data.success) {
            this.plan = res.data.data.list
            this.pageSize = res.data.data.pages
            this.pageNo = this.page
            this.pageTotal = res.data.data.size
            this.total = res.data.data.total
          }
        })
      }
    },
    jump (page) {
      this.page = page
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-aside{
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    position: relative;
  }
  .el-main{
    padding: 0;
  }
  .aside-top{
    height: 5px;
    background: #f5971d;
    width: 100%;
  }
  .el-aside .title{
    background: #ffffff;
    height: 50px;
    line-height: 50px;
    text-align: left;
    font-weight: bold;
    font-size: 18px;
    color: #30313a;
    padding-left: 20px;
  }
  .customerInfo{
    width: 100%;
    height: 50px;
    /*background: #fff;*/
    box-shadow: 0px 0px 10px 0px
    rgba(0, 0, 0, 0.1);
    font-size: 12px;
    color: #30313a;
    text-align: left;
    padding-left:20px;
    position: relative;
  }
  .close{
    width: 50px;
    height: 50px;
    background: #ff5555;
  }
  .customerInfo span{
    color: #b9b9b9;
  }
  .line{
    height: 32px;
    background: #f3f4f7;
    width: 1px;
    margin: 0 20px;
  }
  .menuList{
    color: #30313a;
    font-size: 14px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: dashed 1px #e2e2e2;
  }
  .menuActive{
    color: #ffffff;
    font-size: 14px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5971d;
    border-bottom: dashed 1px #f5971d;
  }
  .hr{
    width: 100%;
    height: 1px;
    background: #e2e2e2;
    margin: 10px 0;
  }
  .hr-dashed{
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e2e2e2;
    margin: 12px 0;
  }
  .content{
    padding: 10px 20px;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/customer/drawings.vue